module.exports = __webpack_public_path__ + "img/plus_btn.355f5d1a.png";